import { h } from "preact";

import IconProps from "./IconProps";

function IconGoogleMonochrome({ width, height, color, class: cssClass }: IconProps) {
    return (
        <svg
            width={width}
            height={height}
            class={cssClass}
            viewBox="0 0 18 18">
            <g fill={color}>
                <path d="M988.991 185.71v-3.348h8.424c.126.567.225 1.098.225 1.845 0 5.139-3.447 8.793-8.64 8.793-4.968 0-9-4.032-9-9s4.032-9 9-9c2.43 0 4.464.891 6.021 2.349l-2.556 2.484c-.648-.612-1.782-1.332-3.465-1.332-2.979 0-5.409 2.475-5.409 5.508s2.43 5.508 5.409 5.508c3.447 0 4.716-2.385 4.95-3.798h-4.959v-.009z" transform="translate(-980.000000, -175.000000)"/>
            </g>
        </svg>
    );
}

IconGoogleMonochrome.defaultProps = {
    width: 18,
    height: 18,
    color: "rgba(0, 0, 0, 0.4)"
};

export default IconGoogleMonochrome;
